export default "__VITE_ASSET__2b66dd42__"